/**
 * Counts pages in a PDF blob using pdfjs-dist.
 *
 * @module finalDocuments/utils/getPdfPageCount
 */
import * as pdfjs from "pdfjs-dist";
import { logError } from "../../../utils/customLogger";

if (!pdfjs.GlobalWorkerOptions.workerSrc) {
  pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
}

/**
 * Returns the number of pages in a PDF `File` or `Blob`.
 *
 * @input file - PDF blob whose page count should be read
 * @return Page count, or 0 when the document cannot be parsed
 */
export const getPdfPageCount = async (file: Blob): Promise<number> => {
  try {
    const data = new Uint8Array(await file.arrayBuffer());
    const pdf = await pdfjs.getDocument({ data }).promise;
    const pageCount = pdf.numPages;
    await pdf.destroy();
    return pageCount;
  } catch (error) {
    logError(error as Error, "Error counting PDF pages");
    return 0;
  }
};
